<template>
    <div>
        <Head ><title>Dashboard</title></Head>
        <h1 class="mb-8 text-9xl font-bold">Dashboard</h1>
        <p class="mb-8 leading-normal">Hey there! Welcome to Ping CRM, a demo app designed to help illustrate how <a
            class="text-indigo-500 hover:text-orange-600 underline" href="https://inertiajs.com">Inertia.js</a> works.
        </p>
        <el-button @click="onGet" type="primary">Fetch data</el-button>
    </div>
</template>

<script>
import {Head} from '@inertiajs/inertia-vue'
import Layout from '@/Layouts/AppLayout'

export default {
    components: {
        Head,
    },
    layout: Layout,

    mounted() {
        // this.$store.dispatch('config/onSetPageTitle', 'INIT FROM CLIENT')
    },
    methods: {
        onGet() {
            this.$axios.get('users').then((res) => {
                console.log(res);
            })
        }
    }
}
</script>
